import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, cartId } from "../lib/api";
import { translate } from "../lib/i18n";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

function initialLocale() {
  const saved = JSON.parse(localStorage.getItem("om_locale") || "null");
  if (saved && saved.market === "CA") return saved;
  const lang = "fr";
  return { market: "CA", lang };
}

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState({ markets: [], brands: [], categories: [] });
  const [locale, setLocaleState] = useState(initialLocale);
  const [cart, setCart] = useState({ items: [], total: 0, currency: "CAD", taxes: [] });
  const [site, setSite] = useState({});
  const reloadSite = useCallback(() => api.get("/store/site").then((r) => setSite(r.data || {})).catch(() => {}), []);

  const setLocale = (l) => {
    const next = { ...locale, ...l };
    localStorage.setItem("om_locale", JSON.stringify(next));
    setLocaleState(next);
  };
  const t = useCallback((k, v) => translate(locale.lang, k, v), [locale.lang]);

  const refreshCart = useCallback(async () => {
    try {
      const { data } = await api.get("/cart", { params: { market: locale.market } });
      setCart(data);
    } catch {
      /* ignore */
    }
  }, [locale.market]);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  const onLogin = async (u) => {
    setUser(u);
    await api.post("/cart/merge", { cart_id: cartId() }).catch(() => {});
    refreshCart();
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setCart({ items: [], total: 0, currency: cart.currency });
  };

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) setUser(false);
    else checkAuth();
    api.get("/store/config").then((r) => setConfig(r.data)).catch(() => {});
    reloadSite();
  }, [checkAuth, reloadSite]);
  useEffect(() => {
    refreshCart();
  }, [refreshCart, user]);

  return (
    <Ctx.Provider value={{ user, setUser, onLogin, logout, config, locale, setLocale, t, cart, setCart, refreshCart, site, reloadSite }}>
      {children}
    </Ctx.Provider>
  );
}
